import { IconError } from '@tvg/fuse-icons';
import React from 'react';

const checkboxConfig = {
	errorIcon: {
		icon: <IconError />,
		color: 'var(--color-universal-redMid)',
		className: 'fuse-checkbox__error-icon',
		dataTestId: 'fuse-checkbox__error-icon',
		size: 'small',
	},
	errorText: {
		color: 'var(--color-universal-redMid)',
		className: 'fuse-checkbox__error-text',
		dataTestId: 'fuse-checkbox__error-text',
		size: 'm1',
		tag: 'span',
		type: 'paragraph',
	},
};

export default checkboxConfig;
